// 9fbef606107a605d69c0edbcd8029e5d
import { breakpoints } from '../../../../../styles/themes/TCP/mediaQuery';

const badgeTranformation = 'g_west,w_0.22,fl_relative';

export default {
  CAROUSEL_OPTIONS: {
    autoplay: false,
    arrows: true,
    fade: false,
    speed: 0,
    dots: true,
    dotsClass: 'slick-dots',
    swipe: true,
    slidesToShow: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: breakpoints.values.lg - 1,
        settings: {
          arrows: true,
        },
      },
    ],
  },
};

export const imageData = {
  imgConfig: [
    `t_outfit_img_m,f_auto,q_auto`,
    `t_outfit_img_t,f_auto,q_auto`,
    `t_outfit_img_d,f_auto,q_auto`,
  ],
  badgeConfig: [badgeTranformation, badgeTranformation, badgeTranformation],
};
export const imageDataLowRes = {
  imgConfig: [
    `t_plp_img_m,f_auto,q_auto`,
    `t_outfit_img_t,f_auto,q_auto`,
    `t_outfit_img_d,f_auto,q_auto`,
    `t_t_atb_m,f_auto,q_auto`,
  ],
  badgeConfig: [badgeTranformation, badgeTranformation, badgeTranformation],
};
export const videoData = {
  imgConfig: [
    'e_loop,t_plp_webp_m,f_auto,q_auto',
    'e_loop,t_plp_webp_t,f_auto,q_auto',
    'e_loop,t_plp_webp_d,f_auto,q_auto',
  ],
};

export const videoDataClient = {
  imgConfig: [
    't_plp_vid_m,f_auto,q_auto',
    't_plp_vid_t,f_auto,q_auto',
    't_plp_vid_d,f_auto,q_auto',
  ],
};

export const TOGGLE_OPTION_CONFIG = [
  { iconPath: 'grid-icon', label: 'grid', accessibleLabel: 'grid view' },
  { iconPath: 'list-icon', label: 'list', accessibleLabel: 'list view' },
];

export const NEW_DESIGN_STORAGE_KEY = 'defaultOutfitAndCollectionView';

export const PJ_PLANNER_CAROUSEL_OPTIONS = {
  autoplay: false,
  arrows: true,
  infinite: false,
  swipe: true,
  slide: true,
  swipeToSlide: true,
  touchMove: true,
  slidesToShow: 1,
  slidesToScroll: 1,

  responsive: [
    {
      breakpoint: breakpoints.values.lg - 1,
      settings: {
        slidesToShow: 1.3,
        arrows: false,
      },
    },
  ],
};

export const PJ_PLANNER_ADD_TO_COLLECTION_LIST_CAROUSEL_OPTIONS = {
  autoplay: false,
  arrows: true,
  infinite: false,
  swipe: true,
  slide: true,
  swipeToSlide: true,
  touchMove: true,
  slidesToShow: 9,
  slidesToScroll: 1,

  responsive: [
    {
      breakpoint: 1430,
      settings: {
        slidesToShow: 8,
      },
    },
    {
      breakpoint: 1350,
      settings: {
        slidesToShow: 7,
      },
    },
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 9,
      },
    },
    {
      breakpoint: 1040,
      settings: {
        slidesToShow: 8,
      },
    },
    {
      breakpoint: 980,
      settings: {
        slidesToShow: 7,
      },
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 6,
      },
    },
    {
      breakpoint: 840,
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 5,
      },
    },
  ],
};
